import { fetch } from "@/helpers/fetch"; //引用fetch.js

/** 获取舆情日报
 * get
 * -------------------------------------传入的参数---------------------------------------------
 * openid，
 * reportType 1日报，2周报，3月报
 */
export function getDailyReportList(data) {
    return fetch({
        url: `/api/wechat/artificialWarning/report`,
        method: 'get',
        params: data
    })
}
